/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function () {

  /* Ultimo prezzo letto: testo originale, numero e separatori */
  let lastPrice = null;

  function getQuantity(button) {
    const form = button.closest('form');
    const input =
      form?.querySelector('.quantity-selector input') ||
      form?.querySelector('input[name="quantity"]') ||
      document.querySelector('.quantity-selector input') ||
      document.querySelector('input[name="quantity"]');

    return input ? Math.max(1, parseInt(input.value, 10) || 1) : 1;
  }

  function getBasePrice() {
    const priceElement = document.querySelector('[data-product-price]');
    if (!priceElement) return null;

    const text = priceElement.textContent.trim();

    /* Ultimo importo nel prezzo, con separatori delle migliaia
       punto, virgola, apostrofo o spazio (es. 1 598,00 kr) */
    const matches = text.match(/\d(?:[\d.,'’\s\u00A0\u202F]*\d)?/g);
    if (!matches || !matches.length) return null;

    const raw = matches[matches.length - 1];
    const decimals = raw.match(/[.,](\d{2})$/);
    const intRaw = decimals ? raw.slice(0, -3) : raw;

    lastPrice = {
      text: text,
      raw: raw,
      sep: decimals ? raw.charAt(raw.length - 3) : null,
      thousands: (intRaw.match(/\D/) || [])[0] || null
    };

    const price = parseFloat(
      intRaw.replace(/\D/g, '') + (decimals ? '.' + decimals[1] : '')
    );

    return Number.isFinite(price) ? price : null;
  }

  function formatPrice(total) {
    if (!lastPrice) return total.toFixed(2);

    /* Stessi separatori del prezzo mostrato in pagina */
    const thousands = lastPrice.thousands || (lastPrice.sep === ',' ? '.' : ',');
    const group = function (s) {
      return s.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    };

    let formatted;

    if (lastPrice.sep) {
      const parts = total.toFixed(2).split('.');
      formatted = group(parts[0]) + lastPrice.sep + parts[1];
    } else {
      /* Valute senza decimali (JPY, KRW, HUF) */
      formatted = group(String(Math.round(total)));
    }

    /* Mantiene simbolo e posizione della valuta del prezzo originale */
    return lastPrice.text.replace(lastPrice.raw, formatted);
  }

  function updateAddToCartPrice() {

    const button = document.querySelector(
      'button[data-add-to-cart]'
    );

    if (!button) return;

    const price = getBasePrice();

    if (price === null) return;

    const quantity = getQuantity(button);
    const total = price * quantity;

    let priceSpan = button.querySelector(
      '.custom-add-to-cart-price'
    );

    if (!priceSpan) {

      priceSpan = document.createElement('span');

      priceSpan.className =
        'custom-add-to-cart-price';

      const text = button.querySelector('.btn__text');

      if (text) {
        text.appendChild(priceSpan);
      } else {
        button.appendChild(priceSpan);
      }
    }

    priceSpan.textContent =
      ' · ' + formatPrice(total);
  }


  /* Prima esecuzione */
  updateAddToCartPrice();


  /* Quantità + / - e digitazione manuale */
  document.addEventListener('click', function (event) {

    if (
      event.target.closest('.quantity-selector button')
    ) {
      setTimeout(updateAddToCartPrice, 50);
    }

  });


  document.addEventListener('input', function (event) {

    if (
      event.target.matches(
        '.quantity-selector input, input[name="quantity"]'
      )
    ) {
      updateAddToCartPrice();
    }

  });


  document.addEventListener('change', function (event) {

    if (
      event.target.matches(
        '.quantity-selector input, input[name="quantity"]'
      )
    ) {
      setTimeout(updateAddToCartPrice, 50);
    }

  });


  /* Cambio variante / prezzo */
  const priceElement =
    document.querySelector('[data-product-price]');

  if (priceElement) {

    const observer = new MutationObserver(function () {
      setTimeout(updateAddToCartPrice, 50);
    });

    observer.observe(priceElement, {
      childList: true,
      subtree: true,
      characterData: true
    });

  }


  /* Controllo iniziale dopo il caricamento */
  setTimeout(updateAddToCartPrice, 300);
  setTimeout(updateAddToCartPrice, 1000);

})();


/* Alt text di riserva per le immagini delle schede prodotto
   (correlati, collezioni, ricerca): usa il titolo del prodotto */
(function () {

  function fillProductCardAlts() {
    document.querySelectorAll('.product-item').forEach(function (card) {
      const titleEl = card.querySelector('.product-item__title');
      if (!titleEl) return;

      const title = titleEl.textContent.trim().replace(/\s+/g, ' ');

      card.querySelectorAll('img:not([alt]), img[alt=""]').forEach(function (img) {
        img.alt = title;
      });
    });
  }

  fillProductCardAlts();

  /* Ripete quando arrivano nuove schede (correlati caricati dopo,
     filtri, "carica altri", ricerca) */
  let timer = null;
  new MutationObserver(function () {
    clearTimeout(timer);
    timer = setTimeout(fillProductCardAlts, 200);
  }).observe(document.body, { childList: true, subtree: true });

})();


/* Carrello: box WELCOME10 separato dalla barra spedizione (solo USD)
   + barra spedizione con lo stesso colore ovunque
   + chat nascosta quando il carrello laterale è aperto */
(function () {

  var WELCOME_MIN = 149;
  var busy = false;
  var timer = null;

  var css = document.createElement('style');
  css.textContent =
    '.sd-welcome-box{display:flex;align-items:center;justify-content:center;gap:8px;margin-top:12px;padding:9px 12px;background:#FCF8F4;border:1px solid #ECE7E2;border-radius:8px;font-size:12px;line-height:1.4;color:#5F5A54;text-align:center;}' +
    '.sd-welcome-box strong{font-weight:600;color:#211C17;}' +
    '.sd-welcome-box__code{flex:0 0 auto;padding:2px 8px;background:#fff;border:1px solid #DDD3C8;border-radius:999px;font-size:11px;font-weight:700;letter-spacing:.06em;color:#211C17;}' +
    '.free-shipping__progress-bar{--progress-value-bg:linear-gradient(to right,#f3aa92 0%,#bc5230 100%)!important;}' +
    'body:has(cart-drawer.is-open) shopify-chat{display:none!important;}';
  document.head.appendChild(css);

  function render(subtotal) {
    var isUSD = window.Shopify && Shopify.currency && Shopify.currency.active === 'USD';

    document.querySelectorAll('.free-shipping').forEach(function (bar) {
      var box = bar.querySelector('.sd-welcome-box');
      var html = '';

      if (isUSD && subtotal > 0) {
        html = subtotal < WELCOME_MIN
          ? '<span>You\'re <strong>$' + (WELCOME_MIN - subtotal).toFixed(2) + '</strong> away from 10% off your first order</span><span class="sd-welcome-box__code">WELCOME10</span>'
          : '<span><strong>10% off unlocked</strong> on your first order · use</span><span class="sd-welcome-box__code">WELCOME10</span>';
      }

      if (!html) {
        if (box) box.remove();
        return;
      }

      if (!box) {
        box = document.createElement('div');
        box.className = 'sd-welcome-box';
        bar.appendChild(box);
      }

      if (box.innerHTML !== html) box.innerHTML = html;
    });
  }

  function update() {
    if (busy) return;
    busy = true;

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart.items_subtotal_price / 100); })
      .catch(function () {})
      .finally(function () { busy = false; });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(update, 300);
  }

  update();

  ['theme:cart:add', 'theme:cart:change', 'theme:cart:update', 'theme:cart:refresh'].forEach(function (ev) {
    document.addEventListener(ev, schedule);
  });

  document.querySelectorAll('cart-drawer, .free-shipping').forEach(function (el) {
    var target = el.tagName === 'CART-DRAWER' ? el : el.parentElement;

    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var t = mutations[i].target;
        if (!(t.closest && t.closest('.sd-welcome-box'))) {
          schedule();
          return;
        }
      }
    }).observe(target, { childList: true, subtree: true, attributes: true, attributeFilter: ['value'] });
  });

})();


/* Recensioni: numeri presi dal badge ufficiale di Loox (sempre aggiornati) */
(function () {
  var KEY = 'sd_loox_stats';

  function readLoox() {
    var el = document.querySelector('[data-loox-rating][data-loox-raters]');
    if (el) return { rating: el.getAttribute('data-loox-rating'), raters: el.getAttribute('data-loox-raters') };
    var w = document.querySelector('loox-trust-badge-widget[rating][raters]');
    if (w) return { rating: w.getAttribute('rating'), raters: w.getAttribute('raters') };
    return null;
  }

  var stats = readLoox();
  if (stats) {
    try { localStorage.setItem(KEY, JSON.stringify(stats)); } catch (e) {}
  } else {
    try { stats = JSON.parse(localStorage.getItem(KEY)); } catch (e) {}
  }
  if (!stats || !stats.rating || !stats.raters) return;

  function apply() {
    document.querySelectorAll('[data-sd-rating]').forEach(function (n) {
      if (n.textContent !== stats.rating) n.textContent = stats.rating;
    });
    document.querySelectorAll('[data-sd-raters]').forEach(function (n) {
      if (n.textContent !== stats.raters) n.textContent = stats.raters;
    });
  }

  apply();

  /* Il carrello laterale si ricostruisce a ogni modifica: riapplica i numeri */
  var drawer = document.querySelector('cart-drawer');
  if (drawer) {
    var t = null;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(apply, 100);
    }).observe(drawer, { childList: true, subtree: true });
  }
})();